import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from '../State/RootReducer'
import { Company, UserData } from '../State/User/UserModel'
import { updateUserData, updateContactData, updateCompanyAddress } from '../State/User/UserActions'
import { ContactData } from 'src/Libs/user/models'
import { useFetchUserData } from 'src/Hooks/useFetchUserData'

export const useUser = (): {
  userData?: UserData
  setUserData: (user: UserData) => void
  contactData?: ContactData
  setContactData: (contactData: ContactData) => void
  userCompany?: Company
  setUserCompany: (company: Company) => void
  refreshCompany: () => void
} => {
  const { fetchCompany } = useFetchUserData()
  const dispatch = useDispatch()

  const userData = useTypedSelector(state => state.user.userData)
  const setUserData = (userData: UserData): void => {
    dispatch(updateUserData(userData))
  }

  const contactData = useTypedSelector(state => state.user.contactData)
  const setContactData = (contactData: ContactData): void => {
    dispatch(updateContactData(contactData))
  }

  const userCompany = useTypedSelector(state => state.user.company)
  const setUserCompany = (company: Company): void => {
    dispatch(updateCompanyAddress(company))
  }

  /**
   * Refreshes only the company data for the current authenticated user by reloading it from the api and updating
   * the current stored user.
   */
  const refreshCompany = useCallback(() => {
    if (!userData?.Firmen_ID) {
      console.error('No company-ID found for current user')
      return
    }
    fetchCompany(userData.Firmen_ID).then(company => {
      if (company) {
        setUserCompany(company)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCompany, userData?.Firmen_ID])

  return { userData, setUserData, contactData, setContactData, userCompany, setUserCompany, refreshCompany }
}
